/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .mat-form-field-underline{background-color:rgba(63,60,60,.45)!important}[_nghost-%COMP%]   [_ngcontent-%COMP%]::-webkit-input-placeholder{color:red;transition:opacity 250ms ease-in-out}[_nghost-%COMP%]   .mat-form-field-invalid[_ngcontent-%COMP%]   .mat-hint[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]   .error-message[_ngcontent-%COMP%]{color:#b00020;font-size:12px}"];
export { styles as styles };
